<template>
  <div id="main_layout_v2" :class="$mq" >
    <router-link id="header_link" to="/"><img id="header_img" src="@/assets/imgs/v3-header.png" /></router-link>

    <div id="post_detail_container_v3">
      <div class="post_detail">
        <h2 class="mb-3">{{ post.title }}</h2>

        <div class="post-item-detail">
          <p class="post-item-detail-date body-2 mb-3">{{parsed_date.toLocaleString('default', { month: 'long' })}} {{parsed_date.getDate()}}</p>

          <div class="post-item-detail-image mb-3">
            <img :src="post_img_page(post)">
          </div>

          <div class="post-item-post-container mb-2 pb-5">
            <router-view />
          </div>
        </div>

        <div class="post-item-share">
          <div id="channels_container">
            <p><b>Follow us on:</b></p>

            <div id="channels">
              <a href="https://instagram.com/devnullprod">
                <img src="@/assets/imgs/IG.svg" />
              </a>

              <a href="https://x.com/devnullprod">
                <img src="@/assets/imgs/X.svg" />
              </a>

              <a href="https://www.youtube.com/@devnullprod">
                <img src="@/assets/imgs/YT.svg" />
              </a>

              <a href="https://twitch.com/devnullprod">
                <img src="@/assets/imgs/Twitch.svg" />
              </a>

              <a href="https://store.steampowered.com/search/?developer=Dev%20Null%20Productions">
                <img src="@/assets/imgs/Steam.svg" />
              </a>

              <a href="https://www.linkedin.com/company/devnullprod">
                <img src="@/assets/imgs/linkedin.svg" />
              </a>

              <a href="https://www.facebook.com/people/Dev-Null-Prod/100063785149118/">
                <img src="@/assets/imgs/FB.svg" />
              </a>

              <a href="https://www.tiktok.com/@devnullprod">
                <img src="@/assets/imgs/TikTok.svg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>      
</template>

<script>
import HasPost     from "@/mixins/HasPost"

export default {
  name: "PostV3",

  mixins: [
    HasPost
  ]
}
</script>

<style lang="scss">
@import "@/scss/custom.scss";
#main_layout_v2{
  background-color: $black;
  background-image: linear-gradient($black-alpha0, $black 20%), url("~@/assets/imgs/v3-bg.png");
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}

#main_layout_v2 #header_link{
  display: block;
  margin: auto;
}

#main_layout_v2 #header_link #header_img{
  padding-top: 125px;
  margin: auto;
  display: block;
}

#main_layout_v2.xs #header_link #header_img{
  width: 60%;
  padding-top: 50px;
}

#post_detail_container_v3 {
  max-width: min(100%, 912px);
  margin: 0 auto;
  margin-top: 50px;
  padding-left: 24px;
  padding-right: 24px;
  font-family: Alliance No2;
  color: $white;
}

.post-back {
  cursor: pointer;
  margin-bottom: 44px;
  color: $white;

  @media screen and (max-width: 767px) {
    margin-bottom: 30px;
  }

  &:before {
    content: url("~@/assets/imgs/new_arrow_left.svg");
    width: 24px;
    height: 24px;
    margin-right: 11px;
  }
}

.post-back:hover{
  color: $white;
  text-decoration: none;
}

.post_detail h2{
  font-family: Bricolage Grotesque ExtraBold;
}

.post-item-detail {
  &-image {
    height: 500px;
    width: 864px;
    border-radius: 4px;
    background: $grey-1;

    img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }

    @media screen and (max-width: 912px) {
      width: auto; 
      height: auto;
      margin-left: -24px;
      margin-right: -24px;
    }
  }
}

.post-item-post-container {
  .subsection {
    padding: 15px;
  }

  img {
    max-width: 100%;
    display: block;
    margin: auto;
  }

  .img-caption {
    text-align: center;
    margin-bottom: 1.25rem;
    font-style: italic;
  }

  .space-even{
    display: flex;
    justify-content: space-evenly;
  }

  table, th, td{
    border: 1px solid;
  }

  th, td{
    padding: 5px;
  }
}

.post-item-share {
  padding-bottom: 25px;

  @media screen and (max-width: 767px) {
    padding-bottom: 10px;
  }
}

#channels_container{
  margin-bottom: 15px;
  margin: auto;
  border-radius: 50px;
  padding: 15px 25px;
  background-image: linear-gradient($grey-5-alpha62, $black-alpha62);
  display: flex;
  gap: 25px;
  width: fit-content;
}

#channels_container p{
  margin: 0;
}

#main_layout_v2.sm #channels_container,
#main_layout_v2.xs #channels_container{
  flex-direction: column;
  align-items: center;
  gap: unset;
  padding-bottom: 25px;
}

#channels{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 15px;
}

pre{
  background-color: rgb(225, 225, 225);
}
</style>
